<div class="pie-card">
  <div class="pie-header">
    <div>
      <span class="chart-eyebrow">Analytics</span>
      <h2 class="chart-title">Produtos mais vendidos</h2>
      <p class="chart-subtitle">Tabela dos itens mais vendidos com percentual já calculado</p>
    </div>
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="carregarDados()" [disabled]="isLoading">
      Atualizar
    </button>
  </div>

  <div *ngIf="isLoading" class="state-box">
    <div class="spinner-border text-primary" role="status"></div>
    <span>Carregando gráfico...</span>
  </div>

  <div *ngIf="hasError && !isLoading" class="state-box error">
    <span>Não foi possível carregar os produtos mais vendidos.</span>
    <button class="btn btn-primary btn-sm" type="button" (click)="carregarDados()">Tentar novamente</button>
  </div>

  <div *ngIf="!isLoading && !hasError" class="table-shell">
    <div class="table-summary">
      <strong>Total de vendas:</strong> {{ totalVendas }}
      <span>Exibindo todos os itens com rolagem interna</span>
    </div>

    <div class="table-scroll">
      <table class="table table-hover align-middle mb-0">
        <thead class="table-light sticky-head">
          <tr>
            <th scope="col">Produto</th>
            <th scope="col" class="text-center">Qtd. Vendas</th>
            <th scope="col" class="text-end">Participação</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of dados">
            <td>{{ item.nomeProduto }}</td>
            <td class="text-center">{{ item.qtdVendas }}</td>
            <td class="text-end fw-semibold">{{ item.percentualParticipacao | number:'1.0-2' }}%</td>
          </tr>
          <tr *ngIf="dados.length === 0">
            <td colspan="3" class="text-center text-muted py-4">Nenhum produto retornado pelo endpoint.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>